



















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class EvoplaySessionsBody extends Vue {
  @Prop() readonly data!: object;
}
